$(window).on('load', () => {
  // hamburger
  $('.hamburger').on('click', function() {
    $('.header__container').toggleClass('nav_active');
  });
  let header = $('.header');
  $(window).scroll(function() {
    let scroll = $(window).scrollTop();
    // console.log(scroll);
    if (scroll >= 30) {
      header.addClass('darkHeader');
    } else {
      header.removeClass('darkHeader');
    }
  });

  $('.link_youtube').colorbox({
    iframe: true,
    innerWidth: 640,
    innerHeight: 390
  });
  $('.link_vimeo').colorbox({
    iframe: true,
    innerWidth: 500,
    innerHeight: 409
  });
});
